import React, { useEffect, useState } from "react";
import AddScreenTitle from "../components/AddScreenTitle";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";
import Buttons from "../components/Buttons";
import { mainTable } from "../css/Common";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import MainPopup from "../popup-containers/MainPopup";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import ComplaintsListPopup from "../popup-containers/ComplaintsListpopup";
import toast from "react-hot-toast";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import Loader from "../ReusableComponents/Loader";
import ErrorPopup from "../ReusableComponents/ErrorPopup";
import { ComplaintsListHeader } from "../components/HeaderAttribute";

const ComplaintsList = () => {
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [headerData, setHeaderData] = useState([]); 
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [rowIndex, setRowIndex] = useState(false);
  const [popUpData, setPopUpData] = useState(null);
  const [popUpDataDD, setPopUpDataDD] = useState(null);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  var createdBy = sessionStorage.getItem("createdBy");
  const [mstComplaintsListId, setMstComplaintsListId] = useState("");
  const [bindComplaintsListData, setBindComplaintsListData] = useState([]);
  
  var mstClientId = sessionStorage.getItem("MstClientId");

  const [formFields, setFormFields] = useState({
    complaintslist: "",
    description: "",
  });

  const [formFieldsError, setFormFieldsError] = useState({
    complaintslistError: "",
    descriptionError: "",
  });

  useEffect(() => {
    // bind gird datas
    bindComplaintsList();
  }, []);

  const bindComplaintsList = async () => {
    const data={
      mstClientId: 0
    }
    setIsLoading(true); 
    const response = await BindPostAPI(
      data,"ComplaintsListAPI/BindComplaintsList"
    );

    if (response && response.data) {
      setBindComplaintsListData(response.data.Table);
      setIsLoading(false); 
    } else {
      setBindComplaintsListData([]);
    }
  };

  const validateForm = () => {
    const errors = {
      complaintslistError: formFields.complaintslist ? "" : "Enter Complaints",
      // descriptionError: formFields.description ? "" : "Enter Description",
    };
  
    setFormFieldsError(errors);
  
    return Object.values(errors).every((err) => err === "");
  };

  const handleSubmit = async (rowIndex, flag) => {
            
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    const isValid = validateForm();

    if (flag == 1 || flag == 2) {
      if (!isValid) {
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
       
      if (isValid) {
        setIsOpen(false);
        setIsLoading(true);
        const data = {
          mstComplaintsListId: mstComplaintsListId ? mstComplaintsListId : 0,
            // mstClientId : mstClientId,
          complaintslist: formFields.complaintslist,
          description: formFields.description,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI(
          [data],
          "ComplaintsListAPI/IUDComplaintsList"
        );
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Complaints data inserted successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Complaints data insert failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Complaints data modified successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Complaints data modification failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
      }
    } else {
      const data = {
      mstComplaintsListId: mstComplaintsListId
          ? mstComplaintsListId
          : 0,
        createdBy: parseInt(createdBy) ,
        flag: flag,
      };
      const response = await IUDAPI([data], "ComplaintsListAPI/IUDComplaintsList");

      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Complaints data deleted successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
        else if (response.data.Table[0].Result === "ND") {
          toast.success("This Complaints is already used. You cannot delete it! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
         else {
          toast.error("Failed to delete Complaints. 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("Complaints data Inactivated successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Complaints data Inactivated failed 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0].Result === "UB") {
          toast.success("Complaints data activated successfully! 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Complaints data activated failed! 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      }
    }
  };

  const showAdd = () => {
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setVisibleAdd(true);
  };

  const cancel = () => {
    bindComplaintsList();
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setVisibleAdd(false);
    setIsLoading(false);
    setSubmitBtnDisabled(false);
    setMstComplaintsListId("");
    setFormFields({
      ComplaintsList: "",
      Description: "",
    });
    setFormFieldsError({
      ComplaintsListError: "",
      DescriptionError: "",
    });
    setpopUpOpen(false);
  };

  const handleInputChange = (e) => {
        const { name, value } = e.target;
        if(name ==="complaintslist"){
          let updatedValue = value.replace(/[^A-Za-z\s]/g, ""); 
          setFormFields((prev) => ({
            ...prev,
            [name]: updatedValue,
          }));
        }
        else{setFormFields((prev) => ({ ...prev, [name]: value })); }
    
  };

  const handleComplaintsList = (rowIndex, flag) => {
    setpopUpOpen(true);
    if (flag === 1) {
      setViewDetails(true);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 3) {
      setViewDetails(false);
      setDeleteDetails(true);
      setBlockDetails(false);
      setUnBlockDetails(false);
    } else if (flag === 4) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(true);
      setUnBlockDetails(false);
    } else if (flag === 5) {
      setViewDetails(false);
      setDeleteDetails(false);
      setBlockDetails(false);
      setUnBlockDetails(true);
    }

    const rowData = bindComplaintsListData[rowIndex];
    setMstComplaintsListId(
      bindComplaintsListData[rowIndex].MstComplaintsListId
    );

    setPopUpData(rowData);
    setPopUpDataDD(bindComplaintsList);
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    if (!formFields[name]) {
      setFormFieldsError((prev) => ({
        ...prev,
        [`${name}Error`]: `Enter ${name}`,
      }));
    } else {
      setFormFieldsError((prev) => ({
        ...prev,
        [`${name}Error`]: "",
      }));
    }
  };

  console.log("formFieldsError:", formFieldsError);
  const handleEdit = (rowIndex) => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setMstComplaintsListId(
      bindComplaintsListData[rowIndex].MstComplaintsListId
    );
    setFormFields({
      ...formFields,
      complaintslist: bindComplaintsListData[rowIndex].ComplaintsList,
      description: bindComplaintsListData[rowIndex].Description,
    });
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
 <GridPage
  header={ComplaintsListHeader}
  title={"complaints"}
  records={bindComplaintsListData}
  handleEdit={handleEdit}
  handleAction={handleComplaintsList}
  showAdd={showAdd}
  blockview={false}
/>
      )}

      {visibleAdd && (
        <div className="w-full">
          <div className="flex flex-col w-full">
            <div className={mainTable.clientMasterMainAdd}>
              <AddScreenTitle
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                title="complaints"
              />
            </div>
          </div>

          <div class="mx-auto  md:w-[500px] w-full">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form>
                    <InputText
                      inputType="text"
                      title="ComplaintsList"
                      name="complaintslist"
                      classStar="text-red-500"
                      controlFunc={handleInputChange}
                      controlFuncBlur={handleBlur}
                      content={formFields.complaintslist}
                      disabled={false}
                      errorMessage={formFieldsError.complaintslistError}
                      isRequired={true}
                    />

                    <TextArea
                      title="Description"
                      rows={5}
                      name="description"
                      content={formFields.description}
                      resize={false}
                      placeholder="Enter description"
                      controlFunc={(e) =>
                        setFormFields((prev) => ({
                          ...prev,
                          description: e.target.value,
                        }))
                      }
                      controlFuncBlur={() => {}}
                      disabled={false}
                      tabIndex="0"
                      errorMessage={formFieldsError.descriptionError}
                    />

                    <div className="flex justify-center mt-6">
                      <Buttons
                        addScreenTitle={addScreenTitle}
                        updateScreenTitle={updateScreenTitle}
                        disabledBtn={false}
                        viewSaveButton={false}
                        handleSubmit={handleSubmit}
                        cancel={cancel}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
  {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleComplaintsList}
      >
        <div>
          <PopUpScreenTitle
            title="complaints"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <ComplaintsListPopup data={popUpData} data1={popUpDataDD} />
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default ComplaintsList;
